// extracted by mini-css-extract-plugin
module.exports = {"modal__wrapper":"modal-module--modal__wrapper--XJyLL"};